import { memo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import dayjs from 'dayjs';
import DateFilter from '../../../../Filters/DateSelectorFilter';
import { setTripSearchInputs } from '../../../../../store/slices/tripSearch';

const TourStartDateFilter = ({ doOpenDatePicker, setDoOpenDatePicker, tripId }) => {
  const isTripSearch = !tripId;
  const { searchInputs } = useSelector((store) => store.tripSearch);
  const dispatch = useDispatch();

  const handleChange = (value) => {
    if (value) {
      setDoOpenDatePicker(false);
    }
    const payload = {
      ...searchInputs,
    };
    payload.tour = {
      ...payload.tour,
    };
    payload.tour.startDate = value;
    if (!payload.tour.endDate || dayjs(value).diff(payload.tour.endDate, 'day') >= 0) {
      payload.tour.endDate = dayjs(value).add(1, 'day').format('YYYY-MM-DD');
    }
    dispatch(setTripSearchInputs({ ...payload }));
  };

  return (
    <DateFilter
      onChange={handleChange}
      label="Tours from"
      value={searchInputs.tour.startDate}
      defaultValue={searchInputs.tour.startDate}
      minDate={dayjs()}
      variant={isTripSearch ? 'outline-no-radius' : 'outline'}
      filterButtonMaxWidth={clsx('max-w-full', { 'w-full': isTripSearch })}
      doOpenDatePicker={doOpenDatePicker}
      setDoOpenDatePicker={setDoOpenDatePicker}
      bgClassName={isTripSearch ? 'bg-searchInput-0' : undefined}
      textColorClassName={isTripSearch ? 'text-datepicker-0' : undefined}
    />
  );
};

TourStartDateFilter.propTypes = {
  doOpenDatePicker: PropTypes.bool,
  setDoOpenDatePicker: PropTypes.func,
  tripId: PropTypes.string,
};

TourStartDateFilter.defaultProps = {
  doOpenDatePicker: false,
  tripId: undefined,
  setDoOpenDatePicker: () => {},
};

export default memo(TourStartDateFilter);
